import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import { Brand, defaultBrandDataForm } from '../../../app/models/Brand';
import useBrandService from '../../../app/services/hooks/useBrandService';
import BrandFormContainer from './BrandFormContainer';

interface Props {
    brandId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const BrandEdit = ({ brandId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingEditBrand, editBrand, fetchingUpdateBrand, updateBrand } = useBrandService();
    const [brand, setBrand] = useState<Brand>(defaultBrandDataForm);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando marca...');
        editBrand(brandId, {
            onSuccess: (response: ServiceResponse) => {
                setBrand(response.data.brand);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando marca...');
        updateBrand(brandId, brand, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditBrand ? (
        <LazyLoading height="300" />
    ) : (
        <BrandFormContainer
            fetching={fetchingUpdateBrand}
            brand={brand}
            setBrand={setBrand}
            action={update}
            cancel={cancel}
            errorFields={errorFields}
        />
    );
};

export default BrandEdit;
